import { render, staticRenderFns } from "./RegionsDialog.vue?vue&type=template&id=4c25b571"
import script from "./RegionsDialog.vue?vue&type=script&lang=js"
export * from "./RegionsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports